import Model, {ModelErrors} from "./Model";
import HouseholdMemberModel, { HouseholdMemberData, create as createMember } from "./HouseholdMemberModel";

export interface HouseholdData {
  id: number;
  created: string;
  updated: string;
  type: string;
  _embedded?: {members: HouseholdMemberData[]};
}

export default class HouseholdModel extends Model<HouseholdData> {
  members: HouseholdMemberModel[] = [];

  constructor(data?: HouseholdData, errors?: ModelErrors) {
    super(data, errors);

    if (data?._embedded?.members) {
      for (const member of data._embedded.members) {
        this.members.push(createMember(member));
      }
    }
  }

  defaults(): HouseholdData {
    return {
      id: 0,
      created: '',
      updated: '',
      type: '',
    }
  }
}

export function create(data?: HouseholdData, errors?: ModelErrors): HouseholdModel {
  return new HouseholdModel(data, errors);
}
